import { useEffect, useRef, useState } from 'react';

import { cn } from '@/lib/utils';

import { Select } from './ui/select';
import { Textarea } from './ui/textarea';

function InlineEdit({
  className = '',
  disabled = false,
  mode = 'edit',
  onChange,
  options = null,
  placeholder,
  type = 'text',
  value,
}) {
  const tempValue = useRef(value);
  const [editing, setEditing] = useState(false);
  const resolvedValue = typeof value === 'object' && value !== null ? (value.sub || value.value || '') : value;
  const [text, setText] = useState(resolvedValue || '');

  useEffect(() => {
    if (value !== undefined && tempValue.current !== value) {
      tempValue.current = value;
      setText(typeof value === 'object' && value !== null ? (value.sub || value.value || '') : (value || ''));
    }
  }, [value]);

  return (
    <>
      {!editing || disabled || mode === 'static' ? (
        <div
          onClick={() => setEditing(true)}
          className={cn('w-full min-h-10 pb-2 pt-2.5 cursor-text', className)}
        >
          {options?.find(({ value }) => value === text)?.label || text || (
            <span className="text-gray-500">{placeholder}</span>
          )}
        </div>
      ) : type === 'select' ? (
        <Select
          autoFocus
          className={cn('-ml-3 pl-2', className)}
          onBlur={() => setEditing(false)}
          onChange={(e) => {
            setText(e.target.value);
            onChange?.(e.target.value);
          }}
          value={text}
        >
          {text === '' && <option value="">{placeholder}</option>}
          {options?.map(({ disabled: optionDisabled, label, value }) => (
            <option disabled={optionDisabled} key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
      ) : (
        <Textarea
          autoFocus
          autoResize
          className={cn('-ml-3 min-h-0 resize-none py-2', className)}
          onBlur={() => setEditing(false)}
          onChange={(e) => {
            const newValue = e.target.value;
            setText(newValue);
            onChange?.(newValue);
          }}
          onKeyDown={({ key, shiftKey, target }) => {
            if (key === 'Enter' && !shiftKey) target.blur();
          }}
          placeholder={placeholder}
          value={text}
        />
      )}
    </>
  );
}

export default InlineEdit;
